import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function Buses() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: mapsRef,
    isVisible: mapsVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: scheduleRef,
    isVisible: scheduleVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="buses" className="relative py-[var(--space-4xl)] bg-[var(--color-dark-background)]">
      <div className="container mx-auto max-w-[56rem] text-center">

        {}
        <div ref={headingRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 className="text-[2.125rem] font-display font-semibold leading-[1.3] text-[var(--color-foreground-dark)] mb-[var(--space-xl)]">
            Autobuses
          </h2>
        </div>

        {}
        <div ref={textRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] delay-100 ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <p className="text-[var(--color-foreground-dark)] text-lg leading-relaxed mb-[var(--space-2xl)]">
            Queremos que solo os preocupéis de disfrutar.
            <span className="block mt-2">
              Por eso, habrá autobuses que os llevarán desde la iglesia hasta el
              lugar del banquete y de vuelta al final de la fiesta.
              <br />
              Las plazas de aparcamiento en el pazo son limitadas y en la zona
              hay muy poco espacio para estacionar, por lo que os recomendamos
              utilizar el servicio de autobús.
            </span>
            <span className="block mt-2">
              Así podremos celebrar juntos sin prisas ni preocupaciones.
            </span>
          </p>

          <p className="text-[var(--color-foreground-dark)]/80 text-base leading-relaxed mb-[var(--space-3xl)]">
            Para todos aquellos que utilicéis vuestro coche para ir a la
            Concatedral, os dejamos abajo la ubicación de un parking cercano.
          </p>
        </div>

        {}
        <div ref={mapsRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] delay-200 ${mapsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"} mb-[var(--space-3xl)]`}>
          <h3 className="text-[2.125rem] font-display font-semibold leading-[1.4] text-[var(--color-foreground-dark)] mb-[var(--space-xl)]">
            Ubicaciones de interés
          </h3>

          <div className="grid md:grid-cols-2 gap-[var(--space-xl)] mb-[var(--space-2xl)]">

            {}
            <div className="rounded-[var(--radius-lg)] p-[var(--space-lg)] shadow-medium !text-[hsl(0,0%,100%)] !bg-[hsl(0,0%,100%)]">
              <h4 className="text-[2.125rem] font-display font-medium leading-[1.5] mb-[var(--space-md)] !text-[hsl(0,0%,0%)]">
                Autobús al pazo
              </h4>

              <div className="relative w-full h-[300px] rounded-[var(--radius-md)] overflow-hidden mb-[var(--space-md)]">
                <img src="https://dondeseacabaelmar.com/wp-content/uploads/2026/02/20190423-204922-largejpg.jpg" alt="Ubicación autobús al pazo" className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
              </div>

              {}
              <p className="text-sm mb-[var(--space-md)] !text-[hsl(0,0%,0%)]">
                Oficina de Correos y Citypaq  
                <br />
               Praza de Galicia, S/N, 15402 Ferrol, A Coruña
              </p>

              <Link to="https://www.google.com/maps/search/?api=1&query=Oficina+de+Correos+y+Citypaq+Ferrol" newTab className="inline-block w-full">
                <button className="w-full btn-primary">
                  Cómo llegar
                </button>
              </Link>
            </div>

            {}
            <div className="rounded-[var(--radius-lg)] p-[var(--space-lg)] shadow-medium !bg-[hsl(0,0%,100%)]">
              <h4 className="text-[2.125rem] font-display font-medium leading-[1.5] mb-[var(--space-md)] !text-[hsl(0,0%,0%)]">
                Parking cercano
              </h4>

              <div className="relative w-full h-[300px] rounded-[var(--radius-md)] overflow-hidden mb-[var(--space-md)]">
                <img src="https://dondeseacabaelmar.com/wp-content/uploads/2026/02/el-canton_img102227t0.jpg" alt="Parking El Cantón" className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
              </div>

              {}
              <p className="text-sm mb-[var(--space-md)] !text-[hsl(0,0%,0%)]">
                Parking El Cantón  
                <br />
              Plaza de la Constitución, s/n, 15403 Ferrol, A Coruña
              </p>

              <Link to="https://www.google.com/maps/search/?api=1&query=Parking+El+Cantón+Ferrol" newTab className="inline-block w-full">
                <button className="w-full btn-primary">
                  Cómo llegar
                </button>
              </Link>
            </div>

          </div>
        </div>

        {}
        <div ref={scheduleRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] delay-300 ${scheduleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h3 className="text-[2.125rem] font-display font-semibold leading-[1.4] text-[var(--color-foreground-dark)] mb-[var(--space-xl)]">
            Horario de Autobuses
          </h3>

          <div className="text-[var(--color-foreground-dark)]/70 text-sm leading-relaxed">
            Los autobuses saldrán puntualmente. Por favor, llegad pronto y no os entretengáis demasiado.
          </div>
        </div>

      </div>
    </section>;
}